import { createRoot } from 'react-dom/client';

import WordFinder from './WordFinder';
import './styles.css';

const domNode = document.getElementById('word-finder');
const root = createRoot(domNode);
root.render(<WordFinder/>);
